import { render, staticRenderFns } from "./Headlines.vue?vue&type=template&id=8a7b9960&scoped=true"
import script from "./Headlines.vue?vue&type=script&lang=ts"
export * from "./Headlines.vue?vue&type=script&lang=ts"
import style0 from "./Headlines.vue?vue&type=style&index=0&id=8a7b9960&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7b9960",
  null
  
)

export default component.exports